// extracted by mini-css-extract-plugin
export default {"Error404Page":"Error404_Error404Page__VGRvT","label":"Error404_label__jcP3O","title":"Error404_title__Tapnm","description":"Error404_description__-aLRk"};